// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2Qoib","topBottomGutter":"Layout_topBottomGutter__2ovs6"};